import { handleActions } from 'redux-actions';
import {
  setConfig,
  setErrorMessage,
  setSuccessMessage,
  userRequestData,
  userReceiveData,
  userFailLoadData,
} from '../actions/contact-actions';
import { ContactRecord } from '../records/contact-record';
import { UserRecord } from '../../shared/records/user-record';

export const initialState = new ContactRecord();
export const emptyUser = new UserRecord();

export default handleActions(
  {
    [setConfig]: (state, action) => state.set('config', action.payload),
    [setErrorMessage]: (state, action) =>
      state.set('errorMessage', action.payload).set('isLoading', false),
    [setSuccessMessage]: (state, action) =>
      state.set('successMessage', action.payload).set('isLoading', false),
    [userRequestData]: state => state.set('isLoading', true),
    [userReceiveData]: (state, action) =>
      state.set('authorizedUser', action.payload).set('isLoading', false),
    [userFailLoadData]: state => state.set('authorizedUser', emptyUser).set('isLoading', false),
  },
  initialState
);
